<template>
  <div>
    导航编号
   <el-input v-model="postForm.navguid" style="width: 200px;"></el-input>
   <el-button type="info" @click="clickpost">获取日志</el-button>
   lat
   <el-input v-model="postForm.lat" style="width: 150px;"></el-input>
   lng
   <el-input v-model="postForm.lng" style="width: 150px;"></el-input>
   direction
   <el-input v-model="postForm.direction" style="width: 60px;"></el-input>
   <el-button type="info" @click="clickGetNavMessage">获取导航语音提醒</el-button>
   当前状态：{{curstatus}};当前目标点编号：{{curindex}};语音提醒：{{navmessage}}
   <div id="allmap" class="bm-view"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      postForm: {
        navguid: '161234307681466209260', // 161191298601376394034
        lat: '31.814910850631',
        lng: '119.90110290247267',
        direction: '100'
      },
      map: null,
      zoom: 21,
      stepindex: 0,
      curstatus: '未知',
      curindex: 0,
      curlng: 0,
      curlat: 0,
      navmessage: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.map = new BMapGL.Map('allmap')
      var point = new BMapGL.Point(119.90125, 31.814908)
      this.map.centerAndZoom(point, this.zoom)
      this.map.enableScrollWheelZoom(true)

      var that = this
      var scaleCtrl = new BMapGL.ScaleControl() // 添加比例尺控件
      this.map.addControl(scaleCtrl)
      var zoomCtrl = new BMapGL.ZoomControl() // 添加比例尺控件
      this.map.addControl(zoomCtrl)
      var navi3DCtrl = new BMapGL.NavigationControl3D() // 添加3D控件
      this.map.addControl(navi3DCtrl)
      this.map.addEventListener('click', function (e) {
        // that.postForm.origin = '' + e.latlng.lat + ',' + e.latlng.lng
        that.postForm.lat = e.latlng.lat
        that.postForm.lng = e.latlng.lng
      })
      this.map.addEventListener('rightclick', function (e) {
        // that.postForm.destination = '' + e.latlng.lat + ',' + e.latlng.lng
      })
    },
    clickpost () {
      this.apiBmapRslptLog()
    },
    clickGetNavMessage () {
      this.apiGetNavMessage()
    },
    drawCircle (lng, lat) {
      var fillColor = 'green'

      var circle = new BMapGL.Circle(new BMapGL.Point(lng, lat), 1, {
        fillColor: fillColor,
        strokeWeight: 0
      })
      this.map.addOverlay(circle)

      this.stepindex++
    },
    drawPolyline (lng1, lat1, lng2, lat2) {
      var polyline = new BMapGL.Polyline([
        new BMapGL.Point(lng1, lat1),
        new BMapGL.Point(lng2, lat2)
      ], { strokeColor: 'blue', strokeWeight: 2, strokeOpacity: 0.5 })
      this.map.addOverlay(polyline)
    },
    drawMarker (lng1, lat1, lng2, lat2) {
      var myIcon = new BMapGL.Icon('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/arrow4.png', new BMapGL.Size(32, 32), {
        anchor: new BMapGL.Size(16, 16),
        imageOffset: new BMapGL.Size(0, 0)
      })
      var marker = new BMapGL.Marker(new BMapGL.Point(lng2, lat2), { icon: myIcon })
      this.map.addOverlay(marker)

      var angle = Math.atan2((lng1 - lng2), (lat1 - lat2))// 弧度  0.9272952180016122
      var theta = angle * (180 / Math.PI)// 角度  53.13010235415598
      if (theta < 0) {
        theta += 360
      }
      marker.setRotation(theta)
      return theta
    },
    drawMarkerNoInfo (lng, lat, color) {
      var width = 12
      var myIcon = new BMapGL.Icon('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/' + color + '.jpg', new BMapGL.Size(width, width), {
        anchor: new BMapGL.Size(width / 2, width / 2),
        imageOffset: new BMapGL.Size(0, 0)
      })
      var marker = new BMapGL.Marker(new BMapGL.Point(lng, lat), { icon: myIcon })
      this.map.addOverlay(marker)
    },
    drawMarkerInfo (lng, lat, color, info) {
      var width = 12
      var myIcon = new BMapGL.Icon('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/' + color + '.jpg', new BMapGL.Size(width, width), {
        anchor: new BMapGL.Size(width / 2, width / 2),
        imageOffset: new BMapGL.Size(0, 0)
      })

      var that = this
      var point = new BMapGL.Point(lng, lat)
      var marker = new BMapGL.Marker(point, { icon: myIcon })
      that.map.addOverlay(marker)

      var opts = {
        width: 200,
        height: 100,
        title: '日志'
      }
      var infoWindow = new BMapGL.InfoWindow(info, opts)
      marker.addEventListener('click', function () {
        that.map.openInfoWindow(infoWindow, point)
      })
    },
    drawLabel (lng, lat, action) {
      if (action.length > 0) {
        var point = new BMapGL.Point(lng, lat)
        var content = action
        var label = new BMapGL.Label(content, { // 创建文本标注
          position: point,
          offset: new BMapGL.Size(6, 6)
        })
        this.map.addOverlay(label) // 将标注添加到地图中
        label.setStyle({ // 设置label的样式
          color: '#000',
          fontSize: '3px',
          border: '1px solid #1E90FF'
        })
      }
    },
    apiBmapRslptLog: function () {
      var that = this
      var data = {
        navguid: that.postForm.navguid
      }
      axios.post(Vue.prototype.global.Url_BmapRslptLog, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === '200') {
            // 清空覆盖物
            that.map.clearOverlays()

            //
            that.curstatus = '导航异常'
            if (response.data.curstatus === 1) that.curstatus = '导航中'
            if (response.data.curstatus === 2) that.curstatus = '导航结束'
            that.curindex = response.data.curindex

            // 处理路径
            var walkpathsArray = new Array()
            walkpathsArray = response.data.walkpaths.split(';')
            var shanglng = ''
            var shanglat = ''
            for (var i = 1; i <= walkpathsArray.length; i++) {
              var latlngarray = walkpathsArray[i - 1].split(',')
              var curlat = latlngarray[0]
              var curlng = latlngarray[1]
              if (i != 1) {
                that.drawMarker(curlng, curlat, shanglng, shanglat)
                that.drawPolyline(curlng, curlat, shanglng, shanglat)
              }
              if (i == that.curindex) {
                that.curlng = curlng
                that.curlat = curlat
                that.drawMarkerNoInfo(curlng, curlat, 'black')
              }
              shanglng = curlng
              shanglat = curlat
              that.drawCircle(curlng, curlat)
            }

            response.data.navlog.filter((item, i) => {
              that.drawMarkerInfo(item.lng, item.lat, 'red', 'id：' + item.id + '；设备方向：' + item.direction + '；目标方向：' + item.targetdirection + '；API返回值：' + item.returnvalue)
              that.drawPolyline(item.lng, item.lat, item.targetlng, item.targetlat)
              that.drawLabel(item.lng, item.lat, '' + item.id)
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNavMessage: function () {
      var that = this
      var data = {
        deviceid: 'RSLPTC230101',
        lat: that.postForm.lat,
        lng: that.postForm.lng,
        direction: that.postForm.direction,
        guid: that.postForm.navguid,
        sign: '123456',
        coordinatestype: 2
      }

      axios.post(Vue.prototype.global.Url_GetNavMessage, Qs.stringify(data))
        .then(function (response) {
          that.apiBmapRslptLog()
          that.navmessage = response.data
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .bm-view {
    width: 100%;
    height: 680px;
  }
</style>
